import { checkConfigFeatures } from 'utils/misc'

const hasInstrumentFeatures = (config, type) => {
  const accessInstruments = ['ediary', 'clinro']
  return accessInstruments.indexOf(type.toLowerCase()) !== -1 ? checkConfigFeatures(config, [type.toLowerCase()]) : true
}

export default hasInstrumentFeatures
